<div class="loading active" *ngIf="this.loader.getLoading()" @fadeAnimation>
    <div class="loading-inner">
        <div class="page-spinner"></div><span>Cargando...</span>
    </div>
</div>
